export default __webpack_public_path__ + "static/media/ms-word.50c5a022.svg";